export const EMPLOYMENT_HISTORY_ERROR_KEY = "employmentHistory";

export const EMPLOYMENT_HISTORY_REQUIRED_MESSAGE = "Please add at least one employment.";

export const formatEmploymentYears = (years: number): string =>
  years === 1 ? "1 year" : `${years} years`;

export const getEmploymentHistoryHint = (years: number): string =>
  `Please provide your employment history for the last ${formatEmploymentYears(years)}.`;

export const getEmploymentHistoryCoverageMessage = (years: number): string =>
  `Your employment history must cover at least the last ${formatEmploymentYears(years)}.`;

const DATE_ONLY_PREFIX = /^(\d{4})-(\d{2})-(\d{2})/;

const toLocalDateOnly = (value?: string | null): Date | null => {
  if (!value) return null;
  const match = DATE_ONLY_PREFIX.exec(value);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

const subtractYears = (date: Date, years: number): Date => {
  const targetYear = date.getFullYear() - years;
  const lastDayOfMonth = new Date(targetYear, date.getMonth() + 1, 0).getDate();
  return new Date(targetYear, date.getMonth(), Math.min(date.getDate(), lastDayOfMonth));
};

export const getEmploymentHistoryError = (
  entries: { startDate?: string | null }[] | null | undefined,
  requiredYears?: number | null,
  today: Date = new Date()
): string | null => {
  if (!entries || entries.length === 0) return EMPLOYMENT_HISTORY_REQUIRED_MESSAGE;
  if (!requiredYears || requiredYears <= 0) return null;

  const startTimes = entries
    .map((entry) => toLocalDateOnly(entry?.startDate)?.getTime())
    .filter((time): time is number => time !== undefined);
  if (startTimes.length === 0) return null;

  const todayDateOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const requiredStart = subtractYears(todayDateOnly, requiredYears);
  return Math.min(...startTimes) > requiredStart.getTime()
    ? getEmploymentHistoryCoverageMessage(requiredYears)
    : null;
};
